//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      inquiry: {},
      orderId: ""
    };
  },
  created() {
    document.title='问诊单详情';
    this.orderId = this.$route.query.orderId;
    if(!this.$store.state.userInfo.sessionId){
      this.$store.state.userInfo.sessionId = 'haozhongyi';
    }
    this.query();
  },
  methods: {
    query() {
      var _this = this;
      var data = {
        orderID: this.orderId,
        isInterrogationsingle: 1,
        ischecked: 1
      };
      this.$doRequest("/api/Inquiry/orderDetails", data, res => {
        _this.inquiry = res;
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/views/upload/ones/ones.vue